import { ICliJob } from 'cli/types';
import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IQuoteVersionData, IQuoteVersionRequestPayload } from 'quotes/types';

export const getQuoteVersionData = async (
  requestPayload: IQuoteVersionRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/quote/version/get-version-data?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordFromServer<IQuoteVersionData>(data.quote_version_data);
};

export const initializeDraftVersion = async (data): Promise<ICliJob> =>
  (await partfinitiClient.postForm('/quote/customer/initialize-draft-version', data)).cliJob;

export const resetDraftVersion = async (data): Promise<ICliJob> =>
  (await partfinitiClient.postForm('/quote/customer/reset-draft-version', data)).cliJob;

export const releaseDraftVersion = async (data): Promise<ICliJob> =>
  (await partfinitiClient.postForm('/quote/customer/release-draft-version', data)).cliJob;
